import { useState } from 'react'

import { Tab } from 'components'
import { SuccessModal } from 'components/SuccessModal/SuccessModal'
import useLoading from 'hooks/useLoading'
import useToggle from 'hooks/useToggle'
import { RegisterPendingServices } from 'services/NGT/RegisterPendingItems'
import { TipoPendencia } from 'utils/types'

import { RecordsRegistrationForm, RegisterPendingItems } from './components'
import { useModal } from 'hooks'

export default function RecordsRegistration() {
  const tabs = ['Pesquisar', 'Adicionar Novo']
  const [selectedTab, setSelectedTab] = useState(0)
  const { loading, msgErro, setLoading, setMsgErro } = useLoading()
  const [isModalOpen, toggleModal] = useToggle()
  const { showModal } = useModal()

  const handleChange = (_, newValue) => setSelectedTab(newValue)

  const setBackTab = () => {
    setSelectedTab(0)
  }

  const handleAddNewTypePending = (data: TipoPendencia) => {
    setLoading('loading')
    RegisterPendingServices()
      .create({
        ...data
      })
      .then(() => {
        setLoading('idle')
        toggleModal()
      })
      .catch((err) => {
        // setMsgErro(err.title)
        // setLoading('error')
        setLoading('idle')
        showModal({
          hideButtonCancel: true,
          message: err.title,
          type: 'alert'
        })
      })
  }

  return (
    <>
      <Tab tabs={tabs} value={selectedTab} handleChange={handleChange} />
      {selectedTab === 0 ? (
        <RegisterPendingItems />
      ) : (
        <>
          <RecordsRegistrationForm
            handleAddNewTypePending={handleAddNewTypePending}
            msgError={msgErro}
            loading={loading}
            isModalOpen={isModalOpen}
            toggleModal={toggleModal}
            setLoading={setLoading}
            setBackTab={setBackTab}
          />
          <SuccessModal
            open={isModalOpen}
            message="Dados incluídos com sucesso!"
            type="sucess"
            hideButtonCancel
            txtButtonConfirm="OK"
            handleConfirm={() => {
              toggleModal()
              setSelectedTab(0)
            }}
          />
        </>
      )}
    </>
  )
}
